import React, { useEffect } from "react";
import { Redirect, useLocation } from "react-router";
import AuthPage from "./hoc/AuthPage";
import { useFormDetailsActions } from "../context/FormDetailsContext";
import { isInternal } from "../helpers";
import { useOffices } from "../adapters/uplist";
import { Input, Select } from "../components/fields";
import { Form } from "react-bootstrap";

const officeOption = ({ id, name }) => ({ value: id, label: name });

const AccountInfoPage = () => {
  const { state } = useLocation();
  const { setIsRealtor } = useFormDetailsActions();
  const { isRealtor } = state || {};
  const { data: offices } = useOffices();
  useEffect(() => {
    setIsRealtor(isRealtor || isInternal());
  }, [isRealtor, setIsRealtor]);
  if (isRealtor === undefined && !isInternal()) {
    return (
      <Redirect
        to={{
          pathname: "/signup",
          state: { noAnimate: true },
        }}
      />
    );
  }
  const defaultPassword = isInternal() ? Date.now().toString() : "";
  return (
    <AuthPage>
      <Input
        name="first_name"
        type="text"
        label="First Name"
        autoComplete="given-name"
        required
        internalRequired
      />
      <Input
        name="last_name"
        type="text"
        label="Last Name"
        autoComplete="family-name"
        required
        internalRequired
      />
      <Input
        name="email"
        type="email"
        label="Email"
        autoComplete="username"
        required
        internalRequired
      />
      <Input
        name="password"
        type="password"
        label="Password"
        autoComplete="new-password"
        defaultValue={defaultPassword}
        hidden={isInternal()}
        password
        required
      />
      <Input
        name="password_confirmation"
        type="password"
        label="Confirm Password"
        autoComplete="new-password"
        defaultValue={defaultPassword}
        hidden={isInternal()}
        password
        required
      />
      <Input
        name="phone_number"
        type="tel"
        label="Phone Number"
        autoComplete="tel"
        required
        placeholder="250-388-6998"
      />
      {(isRealtor || isInternal()) && (
        <>
          <Input
            name="mls_id"
            type="text"
            label="MLS Agent Id"
            autoComplete="none"
            required
          />
          {offices && (
            <Select
              options={offices?.map(officeOption)}
              name="office_id"
              label="Realty Office"
              placeholder="Search..."
              required
              isClearable
              creatable
              isLoading={!offices}
            />
          )}
        </>
      )}
      <Form.Text>This site is protected by reCAPTCHA and the Google</Form.Text>
      <Form.Text>
        <a href="https://policies.google.com/privacy">Privacy Policy</a> and{" "}
        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
      </Form.Text>
    </AuthPage>
  );
};

export default AccountInfoPage;
